import React, { useEffect } from "react";
import useState from "react-usestateref";

// import Pagination from "react-js-pagination";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import Pagination from "@material-ui/lab/Pagination";
import { Box, CircularProgress, Modal, Typography } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import { postMethod } from "../core/service/common.api";
import moment from "moment";
import SearchBar from "./searchbar";
import * as Icons from "@material-ui/icons";
import Skeleton from "react-skeleton-loader";
import { RxCrossCircled } from "react-icons/rx";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";
import CsvDownloader from "react-csv-downloader";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: "10px",
  // p: 4,
};

function NewblocksentialContact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [getP2POrders, setgetAllp2pOrders, getP2POrdersref] = useState([]);
  const [totalPage, setTotalpages] = useState(0);
  const [pageloader, setpageloader] = useState(true);

  const [open, setOpen] = useState(false);
  const [viewcontact, setviewcontact] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [validopen, setvalidOpen] = useState(false);

  const handlevalidOpen = () => setvalidOpen(true);
  const handlevalidClose = () => setvalidOpen(false);

  var classes = useStyles();
  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getContacts();
  }, []);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [activefilter, setActivefilter] = useState(false);
  const [exportData, setexportData, exportDataref] = useState([]);

  const getContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.newnblockform,
        payload: payload,
      };
      console.log(data);
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setgetAllp2pOrders(resp.data.data);
        const formattedData = resp.data.exportData.map((item, index) => ({
          "Name ": item.userName,
          Medium: item.medium,
          "Medium Value": item.mediumvalue,
          "Mobile Number": item.mobileNumber,
          Country: item.country,
          "Message ": item.comments,
          "Received Date ": moment(item.createdAt).format("lll"),
      }));
        setexportData(formattedData);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {
      console.log("err", error);
    }
  };

   const changeStatus = async (value) => {
      var payload = {
        _id: viewcontact._id,
        status: value,
      };
      var data = {
        apiUrl: apiService.changeBlockContactstatus,
        payload: payload,
      };
  
      var resp = await postMethod(data);
      if (resp.success == true) {
        toast.success(resp.Message);
        getContacts();
        handlevalidClose();
      } else {
        toast.error(resp.Message);
      }
    };

  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getContacts(1);
  };

  const download = async () => {
    if (exportDataref.current.length > 0) {
      toast.success("BlockSentinals contacts download succesfully");
    } else {
      toast.error("No record found");
    }
  };
  const enquiry = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "read",
      };
      var data = {
        apiUrl: apiService.changestatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        getContacts();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };

  return (
    <>
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Block sentinels Contact
          </Typography>
          {/* <SearchBar
            placeholder="Search by Name"
            onSearch={(term) => getContacts(1, term)}
          /> */}
          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
              // onSearch={(term) => getContacts(1, term)}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>

            <div onClick={download}>
              <CsvDownloader
                filename="Blocksentinals Contacts"
                extension=".csv"
                separator=","
                wrapColumnChar={`"`}
                datas={exportDataref.current}
                className="csvbutton"
                disabled={!(exportDataref.current?.length > 0)}
              >
                <i className="fas fa-file-excel"></i> Export
              </CsvDownloader>
            </div>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table table-striped textwraping">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Name </th>
                  <th> Medium</th>
                  <th> Medium Value</th>
                  <th> Mobile Number</th>
                  <th> Country</th>
                  <th> Message </th>
                  <th> Received Date </th>
                  <th> Status </th>
                  <th> Validity Status </th>
                </tr>
              </thead>
              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                        <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : getP2POrdersref.current.length > 0 ? (
                  getP2POrdersref.current &&
                  getP2POrdersref.current.map((orders, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>
                          {orders.userName.substring(0, 15)}{" "}
                          {orders.length > 10 ? "..." : ""}
                        </td>
                        <td>{orders.medium}</td>
                        <td>{orders.mediumvalue}</td>
                        <td>{orders.mobileNumber}</td>
                        <td>{orders.country}</td>
                        <td>{orders.comments.substring(0, 15)}...</td>
                        <td>{moment(orders.createdAt).format("lll")}</td>
                        <td
                          onClick={() => {
                            handleOpen();
                            setviewcontact(orders);
                          }}
                        >
                          <i class="fa-solid fa-eye  cursor-pointer"></i>
                        </td>
                         <td>
                                                  {orders.contactStatus === "active" ? (
                                                    <p
                                                      className="mb-0 cursor-pointer btn_add btn_activechange"
                                                      style={{ color: "white", Cursor: "pointer" }}
                                                      onClick={() => {
                                                        handlevalidOpen();
                                                        setviewcontact(orders);
                                                      }}
                                                    >
                                                      Active
                                                    </p>
                                                  ) : orders.contactStatus === "Valid" ? (
                                                    <p
                                                      className="mb-0"
                                                      style={{ color: "green", cursor: "not-allowed",textAlign:'center' }}
                                                    >
                                                      Valid
                                                    </p>
                                                  ) : (
                                                    <p
                                                      className="mb-0"
                                                      style={{ color: "red", cursor: "not-allowed",textAlign:'center' }}
                                                    >
                                                      Invalid
                                                    </p>
                                                  )}
                                                </td>

                        {/* <td>
                    {orders.readStatus == "notread" ? (
                      <p
                        style={{ color: "green" }}
                        onClick={() => enquiry(orders)}
                      >
                        {" "}
                        Open{" "}
                      </p>
                    ) : (
                      <p style={{ color: "red" }}> Closed </p>
                    )}
                  </td> */}
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={13}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination
          count={totalPage}
          page={currentPage}
          onChange={(e, value) => handlePageChange(value)}
          className={`${classes.blog_pagination} mt-4`}
          color="primary"
          shape="rounded"
        />
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_top">
              <h5>Contact Information</h5>
              <RxCrossCircled
                className="modal_close_icon"
                onClick={handleClose}
              />
            </div>
            <div className="modal_bottom">
              <div className="modal_details">
                <h6>Name</h6>
                <p>{viewcontact.userName ? viewcontact.userName : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Mobile Number</h6>
                <p>
                  {viewcontact.mobileNumber ? viewcontact.mobileNumber : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Message</h6>
                <p>{viewcontact.comments ? viewcontact.comments : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Country</h6>
                <p>{viewcontact.country ? viewcontact.country : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Medium</h6>
                <p>
                  {viewcontact.mediumvalue ? viewcontact.mediumvalue : "--"}
                </p>
              </div>
            </div>
            <div className="d-flex"></div>
          </Box>
        </Modal>

        <Modal
                  open={validopen}
                  onClose={handlevalidClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <div className="modal_close_icon_valid2">
                      <RxCrossCircled
                        className="modal_close_icon_valid"
                        onClick={handlevalidClose}
                      />
                    </div>
                    <h5 className="logout_title mt-4"> Notification</h5>
        
                    <p className="logout_content">
                      Hi, please confirm whether this contact is valid or invalid.
                    </p>
                    <div className="logout_btn_wrapper p-3">
                      <button
                        className="logout_confirm custom_btn2 text-center"
                        onClick={() => changeStatus("Valid")}
                      >
                        Valid
                      </button>
                      <button
                        className="logout_cancel custom_btn2 text-center"
                        onClick={() => changeStatus("Invalid")}
                      >
                        Invalid
                      </button>
                    </div>
                  </Box>
                </Modal>

      </div>
    </>
  );
}

export default NewblocksentialContact;
